import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { call, takeEvery } from 'redux-saga/effects';
import {
  SystemSecurityForm,
  mountForm,
  unmountForm,
  mountTable,
  unmountTable,
} from '@kineticdata/react';
import { generateFormButtons, FormError, TableField } from '@kineticdata/ui';
import { regRoute, regSaga } from '../../store';
import { BackgroundTasksList } from '../common/BackgroundTasksList';
import { NavListItemLink } from '../common/NavListItemLink';

const formKey = 'system-setup-security';
const tableKey = 'system-setup-tasks-table';

regRoute('SYSTEM_SECURITY_PAGE', '/system/setup/security/*');

regSaga(
  takeEvery('ENTER_SYSTEM_SECURITY_PAGE', function* () {
    yield call(mountForm, formKey);
    yield call(mountTable, tableKey);
  }),
);
regSaga(
  takeEvery('LEAVE_SYSTEM_SECURITY_PAGE', function* () {
    yield call(unmountForm, formKey);
    yield call(unmountTable, tableKey);
  }),
);

const FormLayout = ({ fields, error, buttons }) => (
  <form>
    <div className="row">
      <div className="col-6">{fields.get('allowedSystemIpsEnabled')}</div>
    </div>
    <div className="row">
      <div className="col-12">{fields.get('allowedSystemIps')}</div>
    </div>
    {error}
    <div className="form-buttons">{buttons}</div>
  </form>
);

export const SystemSetupSecurity = () => (
  <div className="">
    <ul className="nav nav-tabs">
      <NavListItemLink to="/system/setup/security" end>
        Background Tasks
      </NavListItemLink>
      <NavListItemLink to="/system/setup/security/ip">
        System IP Restrictions
      </NavListItemLink>
    </ul>

    <Routes>
      <Route
        path=""
        element={<BackgroundTasksList tableKey={tableKey} omitTitle={true} />}
      />
      <Route path="ip" element={<SystemIPRestrictions />} />
    </Routes>
  </div>
);

const SystemIPRestrictions = () => (
  <div className="content-container">
    <SystemSecurityForm
      formKey={formKey}
      components={{
        FormError,
        FormButtons: generateFormButtons({
          submitLabel: 'Update System Security',
          cancelPath: '/system/setup/config',
        }),
        FormLayout,
      }}
      alterFields={{
        allowedSystemIps: { component: TableField },
        allowedSystemIpsEnabled: { renderAttributes: { switch: true } },
      }}
    >
      {({ form }) => form}
    </SystemSecurityForm>
  </div>
);
